/**
 * formatters.js — Shared formatting utilities.
 *
 * Replaces the identical formatNum() and pct() helpers that were
 * copy-pasted into DashboardWindow.js and PromotionalWindow.js.
 */

/**
 * Format a number with K/M suffix for large values.
 * @param {number|null} n
 * @param {number} decimals
 */
export const formatNum = (n, decimals = 0) => {
  if (n == null || isNaN(n)) return '—';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return Number(n).toFixed(decimals);
};

/**
 * Format a 0-1 float as a percentage string.
 * @param {number|null} n
 */
export const pct = (n) =>
  n == null ? '—' : `${(Number(n) * 100).toFixed(1)}%`;

/**
 * Format an ISO date string to a readable locale string (IST).
 * @param {string} isoString
 */
export const formatDateTime = (isoString) => {
  if (!isoString) return '—';
  return new Date(isoString).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
};
